<template>
  <div
    v-if="produit"
    v-resize:debounce="onResize"
    class="d-flex flex-column cursor-pointer produit-item justify-content-start"
    :class="[
      jel_getClassObject(content),
      { 'produit-desactive': produitDesactivation && produitDesactivation.indDesactive },
      content.nbColonne == 2 ? 'h-100' : 'py-1',
      { 'pt-2': content.elementPremiereLigne },
    ]"
  >
    <b-link
      v-if="isVisible"
      v-bind="jel_getLienBinding(mixinProduitCasino_getLienPageProduit())"
      class="produit-casino overflow-hidden"
      :class="content.nbColonne == 2 || content.isListeHorizontale ? 'm-n4px p-4px' : 'p-1'"
    >
      <template v-if="!content.isListeHorizontale">
        <div class="image position-relative overflow-hidden">
          <div class="disabled-overlay"></div>
          <MediaImageLogo :content="contentMediaImageLogo" />
          <div
            v-if="isLotProgressif && (!produitDesactivation || !produitDesactivation.indDesactive)"
            class="lot-progressif position-absolute h-25 w-100 d-flex justify-content-center align-items-center font-weight-bold"
            :style="{ '--couleur': progressif.couleur ? progressif.couleur : '#060606' }"
            v-html="texteBandeProgressif"
          />
        </div>
        <div class="section-texte">
          <div
            class="titre-jeu graphik_bold pt-0-5 titre-jeu-col-2"
            v-html="mixinProduitCasino_getTitre()"
          ></div>
          <div
            class="mise-jeu graphik_regular font-weight-normal pt-0-5"
            v-html="mixinProduitCasino_getMiseMinMax()"
          ></div>
          <div
            v-if="validationProgressif"
            class="graphik_regular font-weight-normal progressif-multiple"
          >
            {{ $i18n.t('messageComponent.progressifsMultiples') }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="image position-relative overflow-hidden">
          <div class="disabled-overlay"></div>
          <MediaImageLogo :content="contentMediaImageLogo" />
        </div>
        <div class="section-texte text-center typography-carte-liste-mobile">
          <div
            class="titre-jeu graphik_medium pt-0-5 titre-jeu-horizontale"
            v-html="mixinProduitCasino_getTitre()"
          ></div>
          <div v-if="isLotProgressif">
            <div v-if="mntProgressif" class="lot-progressif graphik_bold">
              {{ formatMontantProgressif }}
            </div>
            <div v-else class="progressif-multiple graphik_medium">
              {{ $i18n.tc('messageComponent.progressif', nbProgressif) }}
            </div>
          </div>
        </div>
      </template>
    </b-link>
    <div
      v-else
      v-observe-visibility="{
        callback: visibilityChanged,
        once: true,
      }"
      class="chargement"
    >
      <span>{{ mixinProduitCasino_getTitre(false) }}...</span>
    </div>
  </div>
</template>

<script>
import { ObserveVisibility } from 'vue-observe-visibility';

import { mapGetters } from 'vuex';
import { formatMontant } from '@/helpers/StringHelpers';
import mixinProduitCasino from '@/mixins/casino/mixinProduitCasino';

import MediaImageLogo from '@/components/media/image/MediaImageLogo';

export default {
  name: 'MediaImageLogoProduitCasino3x4',
  components: {
    MediaImageLogo,
  },
  directives: {
    ObserveVisibility,
  },
  mixins: [mixinProduitCasino],
  props: {
    content: { type: Object, required: false },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          progressif: 'Progressif | Progressif | Progressifs',
          progressifsMultiples: '*Progressifs multiples',
        },
      },
      en: {
        messageComponent: {
          progressif: 'Progressive | Progressive | Progressives',
          progressifsMultiples: '*Multiple Jackpots',
        },
      },
    },
  },
  data() {
    return {
      isVisible: false,
      isLargeurSuperieur100px: true,
    };
  },
  computed: {
    ...mapGetters({
      getProduitCasinoByUuid: 'produitCasino/getByUuid',
      getStatutProduit: 'produitCasino/getStatutProduit',
      getProgressifByUuid: 'progressif/getByUuid',
      getProgressifCasinoMontant: 'progressif/getProgressifCasinoMontant',
      isProgressifLotProgressif: 'progressif/isLotProgressif',
    }),
    produit() {
      // On peut recevoir un produit complet ou uniquement son UUID
      return this.content.produit ?? this.getProduitCasinoByUuid(this.content.idProduit);
    },
    produitDesactivation() {
      return this.getStatutProduit(this.produit, this.$isMobile());
    },
    progressif() {
      return this.getProgressifByUuid(this.produit.idProgressif);
    },
    isLotProgressif() {
      return this.isProgressifLotProgressif(this.progressif);
    },
    mntProgressif() {
      return this.getProgressifCasinoMontant(this.progressif);
    },
    formatMontantProgressif() {
      return formatMontant(this.mntProgressif);
    },
    nbProgressif() {
      return this.produit.listeProgressif?.length ?? 0;
    },
    texteBandeProgressif() {
      if (this.mntProgressif && this.nbProgressif > 0) {
        let montant = formatMontant(this.mntProgressif);
        if (this.nbProgressif > 1) {
          montant += '*';
        }
        return montant;
      }
      return this.$i18n.tc('messageComponent.progressif', this.nbProgressif);
    },
    contentMediaImageLogo() {
      return {
        image: this.produit.image || this.$store.state.produitCasino.imageDefaut,
        image2: this.produit.image2,
        image3: this.produit.image3,
        altImage: this.mixinProduitCasino_getTitre(false),
      };
    },
    validationProgressif() {
      return (
        this.isLotProgressif &&
        this.mntProgressif &&
        this.nbProgressif > 1 &&
        (!this.produitDesactivation || !this.produitDesactivation.indDesactive)
      );
    },
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
    onResize() {
      this.isLargeurSuperieur100px = this.$el.clientWidth > 100;
    },
  },
};
</script>

<style lang="scss" scoped>
a:hover {
  text-decoration: none !important;
  div.lot-progressif {
    color: white;
  }
}
.titre-jeu {
  color: $noir-casino;
}
.titre-jeu-horizontale {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  ::v-deep sup {
    display: inline-block;
  }
}
.titre-jeu-col-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  ::v-deep sup {
    display: inline;
  }
}
.mise-jeu {
  color: $noir-casino;
  opacity: 0.7;
  font-size: 0.8rem;
  white-space: nowrap;
}
.lot-progressif {
  color: $gris-casino;
}

.progressif-multiple {
  color: $noir-casino;
  opacity: 0.7;
  white-space: nowrap;
}
.produit-item {
  width: inherit;
}
.image {
  border-radius: 30%;
  div.lot-progressif {
    color: white;
    bottom: 0;
    background-color: var(--couleur);
  }
}

.produit-casino:focus-visible {
  outline: none;
  border-radius: 6px;
  background-color: $bleu-pale-casino;
}

.produit-desactive .disabled-overlay {
  position: absolute;
  width: 100%;
  top: 0;
  background: #ffffff;
  opacity: 0.8;
  height: 100%;
  z-index: 1;
}

::v-deep {
  img {
    max-width: 100%;
  }
}
</style>
